import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { HELP_SUPPORT } from '../../../constants/staticContent';
import { Root, classes } from './utils';
import logo from '../../../assets/common-assets/docu-transcribe-logo(1).png';
import comingSoon from '../../../assets/common-assets/coming soon.png';
import { lightPalette } from '../../../theme';

const Support = () => (
  <Root>
    <Box textAlign="center">
      <Box>
        <img src={logo} alt="page not found" className={classes.logo} />
      </Box>
      <Box>
        <img src={comingSoon} alt="coming soon" className={classes.image} />
      </Box>
      <Typography
        variant="h4"
        color={lightPalette.shoeWax.darker}
        fontFamily="Heebo"
      >
        {' '}
        {HELP_SUPPORT.MESSAGE}
      </Typography>
      <Button variant="contained" className={classes.button}>
        <Typography variant="body1">{HELP_SUPPORT.BUTTON}</Typography>
      </Button>
    </Box>
  </Root>
);

export default Support;
